import React, { useEffect, useState } from 'react';
import {
  Container,
  StorageInfo,
  BarContainer,
  ProgressBar,
  Icon,
  PurpleDot,
} from './StorageStatus.styled';
import TextView from '../../TextView';
import RedCloud from '../../../assets/images/StorageRed.svg';
import GreenCloud from '../../../assets/images/StorageGreen.svg';
import YellowCloud from '../../../assets/images/StorageYellow.svg';
import { getTotalStorage } from '../../../services/api';

const getStorageIcon = (storagePercent) => {
  // Remove the % sign and convert to number
  const percentValue = parseFloat(storagePercent.replace('%', ''));

  if (percentValue < 74) {
    return GreenCloud;
  } else if (percentValue < 89) {
    return YellowCloud;
  } else {
    return RedCloud;
  }
};

const StorageStatus = ({ storageUsed, storagePercent, totalStorage }) => {
  const barWidth = 80;
  console.log(storagePercent, typeof storagePercent, "storagePercent")

  // useEffect(() => {
  //   const fetchStorage = async () => {
  //     try {
  //       const response = await getTotalStorage();
  //       // setTotalStorage(response.data.data.storage_limit);
  //       // setStorageUsed(response.data.data.storage_used);
  //       // setStoragePercent(response.data.data.storage_used_percentage);
  //       console.log('satass', response);
  //     } catch (err) {
  //       console.error('Failed to fetch storage:', err);
  //     }
  //   };

  //   fetchStorage();
  // }, []);

  return (
    <Container>
      <Icon>
        <img src={getStorageIcon(storagePercent)} alt="Storage Icon" />
      </Icon>
      <StorageInfo>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <TextView variant="title">{storageUsed}</TextView>
          <TextView variant="subtitle" color="#6B6F80">
            of {totalStorage} ({storagePercent}) used
          </TextView>
        </div>
        <BarContainer>
          <ProgressBar width={storagePercent} />
        </BarContainer>
        {/* <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
          <PurpleDot />
          <TextView variant="largeText" style={{ fontWeight: '500' }}>
            Wheels
          </TextView>
        </div> */}
      </StorageInfo>
    </Container>
  );
};

export default StorageStatus;
